var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Usuarios del sistema Campus Virtual"}},[_c('section',{staticClass:"pb-4"},[_c('b-row',{staticClass:"match-height"},[_c('b-col',[_c('listaUsuarios')],1)],1),_c('hr')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }